// src/components/analyticsChartUtils.js
// Shared chart chrome for the superadmin analytics dashboard.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "2026-07-01" -> "Jul 1" (string split avoids UTC off-by-one from new Date())
export function formatDateTick(dateKey) {
  if (!dateKey) return '';
  const parts = dateKey.split('-');
  if (parts.length !== 3) return dateKey;
  return `${MONTHS[parseInt(parts[1], 10) - 1]} ${parseInt(parts[2], 10)}`;
}

export const CHART_COLORS = {
  series: '#3b82f6',
  positive: '#16a34a',
  negative: '#dc2626',
  grid: '#e2e8f0',
  axis: '#64748b',
};

export const TOOLTIP_STYLE = {
  background: 'white',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  fontSize: '0.8rem',
};

// "days since ISO timestamp" -> short recency label ("today", "3d", "2w", "5mo")
export function formatRecency(isoString) {
  if (!isoString) return null;
  const then = new Date(isoString);
  if (isNaN(then.getTime())) return null;
  const daysSince = Math.floor((Date.now() - then.getTime()) / (24 * 60 * 60 * 1000));
  if (daysSince <= 0) return 'today';
  if (daysSince < 14) return `${daysSince}d`;
  if (daysSince < 60) return `${Math.floor(daysSince / 7)}w`;
  return `${Math.floor(daysSince / 30)}mo`;
}

// Days since an ISO timestamp, or null
export function daysSince(isoString) {
  if (!isoString) return null;
  const then = new Date(isoString);
  if (isNaN(then.getTime())) return null;
  return Math.floor((Date.now() - then.getTime()) / (24 * 60 * 60 * 1000));
}
